import React, { Component } from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../_services';
import * as signalR from '@aspnet/signalr';

class ReferralPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DistributorInfo: this.props.DistributorInfo,
            header: 'Reset Password',
            userdata: JSON.parse(localStorage.getItem('user')),
            wholesaler: this.props.whName,
            loading: false,
            error: '',
            submitted: false,
            currentpwd: '',
            newpwd: '',
            confirmpwd: '',
            errorCurrentpwd: '',
            errorNewpwd: '',
            errorConfirmpwd: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }

    handleChange(e) {
        $(document).ready(function () {
            $('.Error').removeClass('success');
        });
        const { name, value } = e.target;
        this.setState({ [name]: value, error: '' });

        if (name == 'currentpwd' && name != '') {
            $('#currentpwd').removeClass('errorIcon');
            this.setState({ errorCurrentpwd: '' });
        }
        if (name == 'newpwd' && name != '') {
            $('#newpwd').removeClass('errorIcon');
            this.setState({ errorNewpwd: '' });
        }
        if (name == 'confirmpwd' && name != '') {
            $('#confirmpwd').removeClass('errorIcon');
            this.setState({ errorConfirmpwd: '' });
        }

    }

    handleSubmit(e) {
        try {
            $('#currentpwd').removeClass('errorIcon');
            $('#newpwd').removeClass('errorIcon');
            $('#confirmpwd').removeClass('errorIcon');
            $(document).ready(function () {
                $('.Error').removeClass('success');
            });
            e.preventDefault();
            this.setState({ submitted: true });
            let IsErrorExists = false;
            const { currentpwd, newpwd, confirmpwd } = this.state;

            if (!(currentpwd)) {
                $('#currentpwd').addClass('errorIcon');
                this.setState({ errorCurrentpwd: 'Current password is required' });
                IsErrorExists = true;
            } else if (userService.ValidateSpace(currentpwd)) {
                $('#currentpwd').addClass('errorIcon');
                this.setState({ errorCurrentpwd: 'Space not acceptable' });
                IsErrorExists = true;
            }
            if (!(newpwd)) {
                $('#newpwd').addClass('errorIcon');
                this.setState({ errorNewpwd: 'New password is required' });
                IsErrorExists = true;
            } else if (userService.ValidateSpace(newpwd)) {
                $('#newpwd').addClass('errorIcon');
                this.setState({ errorNewpwd: 'Space not acceptable' });
                IsErrorExists = true;
            } else if (this.state.newpwd.length < 8) {
                this.setState({ errorNewpwd: 'Password must be at least 8 characters' });
                $('#newpwd').addClass('errorIcon');
                IsErrorExists = true;
            }
            if (!(confirmpwd)) {
                $('#confirmpwd').addClass('errorIcon');
                this.setState({ errorConfirmpwd: 'Confirm new password is required' });
                IsErrorExists = true;
            } else if (this.state.newpwd != this.state.confirmpwd) {
                this.setState({ errorConfirmpwd: 'New Password and Confirm Password must match' });
                $('#confirmpwd').addClass('errorIcon');
                IsErrorExists = true;
            }
            if (IsErrorExists == true) {
                return;
            }
            // window.location.origin
            this.Resetpassword(this.state.userdata.email, $.trim(this.state.currentpwd), $.trim(this.state.newpwd), window.location.origin);
        }
        catch (error) {
        }
    }

    Resetpassword(UserEmail, CurrentPassword, NewPassword, RequestURL) {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ UserEmail, CurrentPassword, NewPassword, RequestURL })
        };
        return fetch(`/api/Account/requestpwdupdate`, requestOptions)
            .then(this.handleResponse)
            .then(user => {
                try {
                    this.setState({ loading: false });
                    if (user) {
                        if (user.length > 0) {
                            if (user[0].status_code == "1") {
                                this.ResetSession_BackEnd_SignalR();
                                //this.ResetSession_UI_SignalR();
                                $(document).ready(function () {
                                    $('.Error').addClass('success');
                                });
                                this.setState({ error: user[0].status_message });
                            }
                            else {
                                this.setState({ error: user[0].status_message });
                            }
                        }
                        else {
                            this.setState({ error: 'Whoops, something went wrong. Please try again' });
                        }
                    }
                    else {
                        this.setState({ error: 'Whoops, something went wrong. Please try again' });
                    }
                }
                catch (error) {
                    this.setState({ loading: false });
                    this.setState({ error: 'Whoops, something went wrong. Please try again' });
                }
                return user;
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }

    ResetSession_BackEnd_SignalR = () => {
        try {
            let userAgent = window.navigator.userAgent;
            localStorage.setItem('ch_cred_upl_dt', new Date());
            let connection = new signalR.HubConnectionBuilder().withUrl("/resetSession", {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            }).build();
            connection.start().then(() => {
                connection.invoke("UpdateUserLoginPassword", this.state.userdata.id, "demo", userAgent, this.state.userdata.email).catch(err => console.error(err.toString()));
            });
        } catch (err) {
        }
    }

    render() {
        const { currentpwd, newpwd, confirmpwd, submitted, loading, error, errorCurrentpwd, errorNewpwd, errorConfirmpwd } = this.state;
        return (
            <div className='popup mfp-zoom-in'>
                <div className='popup_inner myinfo referral change-password'>
                    <div className='new-back'>
                        <h1>{this.state.header}<button onClick={this.props.closeResetPasswordPopup}>X</button></h1>
                        <div className="referralPopup">
                            {/*<h3>Our team at {this.state.wholesaler} will reach out to this rep candidate on your behalf</h3>*/}
                            <form autocomplete="off">
                                {loading &&
                                    <div className="theme-loader current-pass"></div>
                                }
                                <div className="form-group">
                                    <label>Current Password</label>
                                    <input type="password" id="currentpwd" className="form-control" name="currentpwd" placeholder={currentpwd} value={currentpwd} onChange={this.handleChange} autoComplete="off" maxLength="16" minLength="8" />
                                    {errorCurrentpwd &&
                                        <div className="Error help-block">{errorCurrentpwd}</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <label>New Password</label>
                                    <input type="password" id="newpwd" className="form-control" name="newpwd" placeholder={newpwd} value={newpwd} onChange={this.handleChange} autoComplete="off" maxLength="16" minLength="8" />
                                    {errorNewpwd &&
                                        <div className="Error help-block">{errorNewpwd}</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <label>Confirm New Password</label>
                                    <input type="password" id="confirmpwd" className="form-control" name="confirmpwd" placeholder={confirmpwd} value={confirmpwd} onChange={this.handleChange} autoComplete="off" maxLength="16" minLength="8" />
                                    {errorConfirmpwd &&
                                        <div className="Error help-block">{errorConfirmpwd}</div>
                                    }
                                </div>
                                <div className="form-group">
                                    <div className="pop-btn">
                                        <button onClick={this.handleSubmit} className="btn">Submit</button><button className="btn cancel" onClick={this.props.closeResetPasswordPopup}>Cancel</button>
                                    </div>
                                </div>
                                {error &&
                                    <div className="Error help-block">{error}</div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReferralPopup;